import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useEffect, useState } from 'react';
import actionLogs from '../../models/action-logs';
import helpers from '../../helpers/common';
import useRootHook from '../../hooks/useRoot';
import { Tooltip, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import Pagination from '../Pagination';

export default function PaymentPageOpensIndex({ fullPage, searchParams, refreshId }) {
    fullPage = typeof fullPage === 'boolean' ? fullPage : true;
    const [data, setData] = useState(null);
    const [detailsRow, setDetailsRow] = useState(null);
    const { setShowLoader } = useRootHook();

    useEffect(() => {
        setShowLoader(true);
        const filters = searchParams ? Object.fromEntries(searchParams) : {};
        actionLogs.getPaymentPageOpens(filters)
            .then((res) => {
                if (res) setData(res);
                setShowLoader(false);
            })
            .catch(() => setShowLoader(false));
    }, [searchParams, refreshId, setShowLoader]);

    if (!data || !data.logs) return null;

    const getCustomerInfo = (log) => {
        if (log.customer) {
            const email = log.customer.email || '-';
            const name = log.customer.name && log.customer.surname
                ? `${log.customer.name} ${log.customer.surname}`.trim()
                : (log.customer.name || '');
            return name ? `${email} (${name})` : email;
        }
        return '-';
    };

    const getAmount = (log) => {
        if (log.amount == null || !log.currency) return '-';
        const symbol = log.currency.symbol || '';
        const subunit = log.currency.subunit || 100;
        return helpers.getSubunitAmountString(log.amount, symbol, subunit);
    };

    return (
        <React.Fragment>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                Красная строка: с этого IP уже была успешная оплата по этому мерчанту.
            </Typography>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Дата / Время</TableCell>
                        <TableCell>IP</TableCell>
                        <TableCell>Устройство</TableCell>
                        <TableCell>User-Agent</TableCell>
                        <TableCell>Клиент</TableCell>
                        <TableCell>Проект</TableCell>
                        <TableCell>Мерчант</TableCell>
                        <TableCell>Сумма</TableCell>
                        <TableCell>Referer</TableCell>
                        <TableCell>Подробнее</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.logs.map((log) => (
                        <TableRow
                            key={`open-${log.id}`}
                            sx={log.risk_same_ip_paid ? { bgcolor: 'error.light', '&:hover': { bgcolor: 'error.main' } } : undefined}
                            title={log.risk_same_ip_paid ? 'С этого IP уже была успешная оплата по этому мерчанту' : undefined}
                        >
                            <TableCell>
                                <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                    {helpers.getTime(log.created)}
                                </Typography>
                                <Typography variant="body2">
                                    {helpers.getDate(log.created)}
                                </Typography>
                            </TableCell>
                            <TableCell>{log.ip_address || '-'}</TableCell>
                            <TableCell>{log.device_info || '-'}</TableCell>
                            <TableCell>
                                <Tooltip title={log.user_agent || ''}>
                                    <Typography variant="body2" sx={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {log.user_agent ? (log.user_agent.length > 50 ? log.user_agent.slice(0, 50) + '…' : log.user_agent) : '-'}
                                    </Typography>
                                </Tooltip>
                            </TableCell>
                            <TableCell>{getCustomerInfo(log)}</TableCell>
                            <TableCell>{log.project?.name || '-'}</TableCell>
                            <TableCell>{log.merchant?.name || '-'}</TableCell>
                            <TableCell>{getAmount(log)}</TableCell>
                            <TableCell>
                                <Tooltip title={log.referer || ''}>
                                    <Typography variant="body2" sx={{ maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {log.referer ? (log.referer.length > 30 ? log.referer.slice(0, 30) + '…' : log.referer) : '-'}
                                    </Typography>
                                </Tooltip>
                            </TableCell>
                            <TableCell>
                                <Button size="small" variant="outlined" onClick={() => setDetailsRow(log)}>
                                    Подробнее
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            {fullPage && <Pagination url="/payment-page-opens" count={data.count} />}
            <Dialog open={!!detailsRow} onClose={() => setDetailsRow(null)} maxWidth="sm" fullWidth>
                <DialogTitle>Открытие страницы оплаты</DialogTitle>
                <DialogContent>
                    {detailsRow && (
                        <Typography component="pre" sx={{ whiteSpace: 'pre-wrap', fontSize: 12 }}>
                            {JSON.stringify({
                                id: detailsRow.id,
                                created: detailsRow.created,
                                ip_address: detailsRow.ip_address,
                                device_info: detailsRow.device_info,
                                user_agent: detailsRow.user_agent,
                                referer: detailsRow.referer,
                                customer: detailsRow.customer,
                                project: detailsRow.project?.name,
                                merchant: detailsRow.merchant?.name,
                                amount: detailsRow.amount,
                                currency: detailsRow.currency?.currency,
                                risk_same_ip_paid: detailsRow.risk_same_ip_paid
                            }, null, 2)}
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDetailsRow(null)}>Закрыть</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
